import PN from "persian-number";
import React, { forwardRef } from "react";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";

import { cn } from "../../../utils/utils";

const CustomPaymentNumberInput = forwardRef((props, ref) => {
  const { control, name, label, errors, placeholder, className, disabled, maxValue, amountRef } = props;

  return (
    <div className={cn("textInputWrapper", className)}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => {
          const handleValueChange = (values) => {
            onChange(PN.convertPeToEn(values.formattedValue));
          };

          return (
            <div className="flex flex-col gap-2" dir="ltr">
              <label dir="rtl" className="text-[20px] font-normal leading-[28px] " htmlFor={name}>
                {label}
              </label>
              <NumericFormat
                value={value ? value : ""}
                displayType={"input"}
                thousandSeparator={true}
                onValueChange={handleValueChange}
                disabled={disabled}
                allowNegative={false}
                placeholder={placeholder}

                className="textInput hover:bg-red-500 text-[20px] font-normal leading-[28px] "
                isAllowed={(values) => {
                  const { floatValue } = values;
                  if (floatValue > maxValue) return false;
                  return true;
                }}
                getInputRef={amountRef} // Pass the ref here for focusing
              />
            </div>
          );
        }}
      />

      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
});

export default CustomPaymentNumberInput;
